import { PurchasedProductInterface } from 'outshared-lib';
import { CoverageGroupTypeEnum } from '../enums';
import { CoverageControlConfigGroupInterface } from '../interfaces';
import { CoverageGroupAbstract } from './coverage-group.abstract';

export class CoverageGroupImplicit extends CoverageGroupAbstract {
    constructor(
        group: CoverageControlConfigGroupInterface,
        purchasedProduct: PurchasedProductInterface,
    ) {
        if (group.inputs.length !== 1) {
            throw new Error(`GroupImplicit only allows 1 input`);
        }

        super(CoverageGroupTypeEnum.Implicit, group, purchasedProduct);
    }
}
